import React from 'react';
import { LinkList } from '../ui/link-list/LinkList';
import { PrenavLink } from '../prenav-link/PrenavLink';

import styles from './top-links.scss';

interface Link {
  id?: number;
  name?: string;
  url?: string;
  menuLinks?: Array<{
    name?: string;
    url?: string;
    external?: boolean;
  }>;
}

interface TopLinksProps {
  links: Link[];
}

export const TopLinks = ({ links }: TopLinksProps) => (
  <LinkList
    links={links}
    Item={PrenavLink}
    className={styles.links}
    children={undefined}
  />
);
